import { createStore } from 'vuex';
import actions from './modules/actions';
import mutations from './modules/mutations';
import demoStore from '@/demo/store';
import chatStore from './modules/chat';

const state = {
    auth: {
        token : null,
        userId: null
    },
    vocabularyList: [],
    readerDocument: null
}

export default createStore({
    state,
    actions,
    mutations,
    modules: {
        demo: demoStore,
        chat: chatStore
    }
})